// Polyfill IE11
Element.prototype.remove = function() {
  this.parentElement.removeChild(this);
}
NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
  for(var i = this.length - 1; i >= 0; i--) {
      if(this[i] && this[i].parentElement) {
          this[i].parentElement.removeChild(this[i]);
      }
  }
}

// Bundle theme module
import Helper from './Classes/Helper';
import FocusHandler from './Classes/FocusHandler';
import LazyLoad from 'vanilla-lazyload';
import ResponsiveTable from "./Classes/ResponsiveTable";
import Header from "./Classes/Header";
import BackToTop from "./Classes/BackToTop";
import SideNav from "./Classes/SideNav";
import Accordion from './Classes/Accordion';
import Link from './Classes/Link';

// import Jump from './Classes/Jump'
// import Sticky from '../../node_modules/sticky-js';

var focusHandlerInstance = null;
var lazyLoadInstance = null;
var responsiveTableInstance = null;
var headerInstance = null;
var backToTopInstance = null
var sideNavInstance = null;
var accordionInstance = null;
var linkInstance = null;

export default {

  version: () => {
    return NSContext.theme.version;
  },

  lazyload: (givenNodeset) => {
    lazyLoadInstance.update(givenNodeset);
  }
};


(function () {
  document.addEventListener('DOMContentLoaded', () => {

    linkInstance = new Link({
      linksSelector: '.js-open-in-new-tab'
    });

    headerInstance = new Header({
      submenuSelector: '.main-menu__wrap--level-1',
      submenuTogglerSelector: '.main-menu__item--has-children .main-menu__link--level-0',
      menuTogglerSelector: '.burger',
      menuContainerSelector: '.header__navigation',
      searchTogglerSelector: '.header__search',
      searchContainerSelector: '.header__searchform'
    });

    focusHandlerInstance = new FocusHandler();

    backToTopInstance = new BackToTop();

    lazyLoadInstance = new LazyLoad();

    sideNavInstance = new SideNav();

    responsiveTableInstance = new ResponsiveTable({
      tableSelector: '.ns-table-wrap table',
      tableWrapperSelector: '.ns-table-wrap',
      breakPointLg: 1200,
      breakPointMd: 768,
      breakPointSm: 480,
      colCountNoSplit: 3,
      colCountEarlyBreak: 7,
      noSplitArray: []
    });

    // new Jump({
    //   graphicSelector: '.ns-graphic'
    // });

    accordionInstance = new Accordion({
      accordions: '.js-toggle-accordion'
    });
  })
})();
